import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots } from "vue";
import global from '@/component-create/utils/global';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import { log } from '@/component-create/utils/log';
import { chineseToPinYin } from '@/component-create/utils/common';
import EventBus from '@/utils/event-bus';

import { toRefs, ref, computed, reactive, watch, onMounted, onUnmounted } from 'vue';
var DICT_CACHE_KEY_PREFIX = 'x-select:dict:';
var LOADER_CACHE_KEY_PREFIX = 'x-select:loader:';
var DEFAULT_LABEL_KEY = 'label';
var DEFAULT_VALUE_KEY = 'value';
var DEFAULT_DICT_LABEL_KEY = 'dataName';
var DEFAULT_DICT_VALUE_KEY = 'dataValue';
var EVENT_INPUT = 'update:modelValue';
var EVENT_PREPARED = 'prepared';
var TYPE_OPTIONS = 'options';
var TYPE_DICT = 'dict';
var TYPE_LOADER = 'loader';
var SELECT_EVENT = 'selected';
/**
 * 字典数据状态
 *
 */
var DICTIONARY_DATA_STATUS;
(function (DICTIONARY_DATA_STATUS) {
  /**
   * 启用
   */
  DICTIONARY_DATA_STATUS["ENABLED"] = "1";
  /**
   * 禁用
   */
  DICTIONARY_DATA_STATUS["DISABLED"] = "0";
})(DICTIONARY_DATA_STATUS || (DICTIONARY_DATA_STATUS = {}));
// eslint-disable-next-line vue/valid-define-emits
export default /*@__PURE__*/_defineComponent({
  __name: 'XSelect',
  props: {
    modelValue: {},
    options: {},
    dictCode: {},
    loader: {},
    labelKey: {
      default: 'label'
    },
    valueKey: {
      default: 'value'
    },
    loaderParam: {},
    allOption: {
      type: Boolean,
      default: false
    },
    allLabel: {
      default: '全部'
    },
    allValue: {
      default: ''
    },
    default: {
      type: [Boolean, Number, String]
    },
    defaultOnNull: {
      type: Boolean,
      default: false
    },
    resetOnReload: {
      default: 'always'
    },
    cache: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: false
    },
    disableOption: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    on: {},
    emit: {},
    elProps: {},
    smartSearch: {
      type: Boolean
    }
  },
  emits: ['update:modelValue', 'selected', 'prepared'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var emit = __emit;
    var prop = __props;
    var LOADERS = global.globalVal[GLOBAL_DATA.LOADERS];
    var REQUEST = global.globalVal[GLOBAL_DATA.SELECT_REQUEST];
    global.subscribe('LOADERS', function (value) {
      LOADERS = value;
    });
    var _toRefs = toRefs(prop),
      modelValue = _toRefs.modelValue,
      disableOption = _toRefs.disableOption,
      elProps = _toRefs.elProps,
      smartSearch = _toRefs.smartSearch;
    // 加载时默认选项值
    var loadingSelect = ref('');
    var selectOptions = ref([]);
    var enableCache = ref(false);
    var loaderIsUpdated = ref(true);
    var realFilter = computed(function () {
      if (prop.smartSearch) {
        return smartFilter;
      } else {
        return undefined;
      }
    });
    var loaderConfig = reactive({
      loaderParam: prop.loaderParam
    });
    var select = reactive({
      type: '',
      loading: false,
      labelKey: '',
      valueKey: '',
      resetValue: false,
      sourceOptions: []
    });
    var EXECUTOR = reactive({
      lazy: false,
      runnable: null,
      execute: function execute(runnable) {
        if (!prop.lazy) {
          runnable();
          return;
        }
        this.runnable = runnable;
      },
      run: function run() {
        if (this.runnable) {
          this.runnable();
        }
      }
    });
    var value = computed({
      get: function get() {
        if (select.loading) {
          return loadingSelect.value;
        }
        return modelValue.value;
      },
      set: function set(v) {
        emit(EVENT_INPUT, v);
        emit(SELECT_EVENT, v);
      }
    });
    watch(modelValue, function (val) {
      customEventEmit(val);
    }, {
      immediate: true
    });
    if (prop.on) {
      EventBus.on(prop.on, function (val) {
        loaderConfig.loaderParam = val;
        select.resetValue = true;
        lazyPerformRequest();
      });
    }
    init();
    if (prop.options) {
      initByOptions();
      select.type = TYPE_OPTIONS;
    } else if (prop.dictCode) {
      initByDictCode();
      select.type = TYPE_DICT;
    } else if (prop.loader) {
      initByLoader();
      select.type = TYPE_LOADER;
    }
    onMounted(function () {
      if (select.type === TYPE_LOADER) {
        if (!isCascadedSelect()) {
          lazyPerformRequest();
        }
      }
      if (modelValue.value) {
        customEventEmit(modelValue.value);
      }
    });
    onUnmounted(function () {
      if (prop.on) {
        EventBus.off(prop.on);
      }
    });
    function smartFilter(value) {
      if (!value) {
        selectOptions.value = select.sourceOptions;
      } else {
        selectOptions.value = select.sourceOptions.filter(function (item) {
          return chineseToPinYin(item[select.labelKey]).replace(/[a-z]/g, '').includes(value.toUpperCase()) || item[select.labelKey].toUpperCase().includes(value.toUpperCase());
        });
      }
    }
    function customEventEmit(val) {
      if (prop.emit) {
        EventBus.emit(prop.emit, val);
      }
    }
    function init() {
      EXECUTOR.lazy = prop.lazy;
      select.labelKey = prop.labelKey;
      select.valueKey = prop.valueKey;
      enableCache.value = prop.cache;
      loaderConfig.loaderParam = prop.loaderParam;
    }
    function initByOptions() {
      setOptions(prop.options || []);
      watch(function () {
        return prop.options;
      }, function (v) {
        setOptions(v || []);
      });
    }
    function initByDictCode() {
      if (isDefaultLabelKey()) {
        select.labelKey = DEFAULT_DICT_LABEL_KEY;
      }
      if (isDefaultValueKey()) {
        select.valueKey = DEFAULT_DICT_VALUE_KEY;
      }
      EXECUTOR.execute(function () {
        performDictLoading();
      });
    }
    function performDictLoading() {
      if (enableCache.value) {
        var cache = getDictCache();
        if (cache && cache.length > 0) {
          setOptions(cache);
          return;
        }
      }
      startLoading();
      if (!REQUEST) {
        log('XSelect', "\u672A\u914D\u7F6E\u9009\u62E9\u5668\u52A0\u8F7D\u8BF7\u6C42\u670D\u52A1\uFF1A".concat(GLOBAL_DATA.SELECT_REQUEST), 'error');
        return;
      }
      REQUEST(prop.dictCode).then(function (result) {
        var data = result.data;
        if (data && data.length > 0) {
          var filtered = data.filter(function (d) {
            return d.status !== DICTIONARY_DATA_STATUS.DISABLED;
          });
          setOptions(filtered);
          setDictCache(filtered);
        } else {
          log('XSelect', "\u672A\u83B7\u53D6\u5230\u8BE5\u5B57\u5178\u4FE1\u606F\uFF1A".concat(prop.dictCode), 'error');
        }
      }).finally(function () {
        stopLoading();
      });
    }
    function initByLoader() {
      var loader = getLoader();
      if (!loader) {
        log('XSelect', "\u8BE5\u52A0\u8F7D\u5668\u672A\u5B9A\u4E49\uFF1A".concat(prop.loader), 'error');
        return [];
      }
      if (isDefaultLabelKey() && loader.labelKey) {
        select.labelKey = loader.labelKey;
      }
      if (isDefaultValueKey() && loader.valueKey) {
        select.valueKey = loader.valueKey;
      }
      if (isCascadedSelect()) {
        enableCache.value = false;
      }
      if (isLoaderParamSpecified()) {
        watchLoaderParam();
      }
    }
    function watchLoaderParam() {
      // 如果指定了loader-param则关闭缓存
      enableCache.value = false;
      watch(function () {
        return prop.loaderParam;
      }, function (val) {
        clearOptions();
        select.resetValue = true;
        loaderConfig.loaderParam = val;
        if (!isCascadedSelect()) {
          lazyPerformRequest();
        }
      }, {
        immediate: true
      });
    }
    function lazyPerformRequest() {
      EXECUTOR.execute(function () {
        return performRequest();
      });
    }
    function performRequest() {
      var _getLoader;
      if (enableCache.value) {
        var cache = getLoaderCache();
        if (cache && cache.length > 0) {
          setOptions(cache);
          return;
        }
      }
      // 减少请求次数
      if (select.loading) {
        loaderIsUpdated.value = false;
        return;
      }
      var request = {
        loaderParam: loaderConfig.loaderParam
      };
      var result = getLoader === null || getLoader === void 0 || (_getLoader = getLoader()) === null || _getLoader === void 0 ? void 0 : _getLoader.request(request);
      if (result && result instanceof Promise) {
        startLoading();
        result.then(function (options) {
          setOptions(options);
          setLoaderCache(options);
        }).catch(function (error) {
          clearOptions();
          log('XSelect', error, 'error');
        }).finally(function () {
          stopLoading();
          if (!loaderIsUpdated.value) {
            loaderIsUpdated.value = true;
            performRequest();
          }
        });
      }
    }
    function setOptions(options) {
      selectOptions.value = [];
      if (options && options.length > 0) {
        var _selectOptions$value;
        (_selectOptions$value = selectOptions.value).push.apply(_selectOptions$value, _toConsumableArray(options));
      }
      if (prop.smartSearch) {
        select.sourceOptions = selectOptions.value;
      }
      doOnOptionsPrepared();
    }
    function clearOptions() {
      selectOptions.value = [];
    }
    function prependAllOption() {
      if (prop.allOption && getOptionsCount() > 0) {
        var option = {};
        option[select.labelKey] = prop.allLabel;
        option[select.valueKey] = prop.allValue;
        prependOptions(option);
      }
    }
    function doOnOptionsPrepared() {
      prependAllOption();
      emit(EVENT_PREPARED, getOptions);
      if (select.resetValue) {
        var policy = prop.resetOnReload;
        var reset = false;
        if (policy === 'always') {
          reset = true;
        } else if (policy === 'miss') {
          reset = true;
          var options = getOptions();
          if (options && options.length > 0) {
            var _iterator = _createForOfIteratorHelper(options),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var option = _step.value;
                if (getOptionValue(option) === getSelectedValue()) {
                  reset = false;
                  break;
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
        if (reset) {
          clearSelectedValue();
        }
        select.resetValue = false;
      }
      if (isDefaultSelectNeeded()) {
        var defaultOp = getDefaultOption();
        if (defaultOp) {
          setSelectedOption(defaultOp);
        }
      }
    }
    /**
     * 获取所有选项
     */
    function getOptions() {
      return selectOptions.value;
    }
    /**
     * 获取选项数量
     */
    function getOptionsCount() {
      return getOptions() ? getOptions().length : 0;
    }
    /**
     * 在开头追加选项
     */
    function prependOptions() {
      var currentOptions = getOptions();
      currentOptions.unshift.apply(currentOptions, arguments);
    }
    /**
     * 在结尾追加选项
     */
    function appendOptions() {
      var currentOptions = getOptions();
      currentOptions.push.apply(currentOptions, arguments);
    }
    function getDefaultOption() {
      var options = getOptions();
      if (!options || options.length === 0) {
        return;
      }
      if (prop.default == null || !options || options.length < 1) {
        return;
      }
      if (prop.default === true) {
        return options[0];
      }
      if (typeof prop.default === 'number') {
        return options[prop.default];
      }
      if (prop.default === 'last') {
        return options[options.length - 1];
      }
      if (prop.default === 'first') {
        return options[0];
      }
    }
    function isDefaultSelectNeeded() {
      return !!prop.default;
    }
    function resetToDefault() {
      var option = getDefaultOption();
      if (option) {
        setSelectedOption(option);
      } else {
        log('XSelect', '重置为默认选项失败，没有匹配的默认选项', 'warning');
      }
    }
    function getSelectedValue() {
      return modelValue.value;
    }
    /**
     * 获取当前选中的对象
     *
     * @returns {null|*} 选中的对象:select.options
     */
    function getSelectedOption() {
      var options = getOptions();
      if (!options || options.length === 0) {
        return null;
      }
      return options.find(function (option) {
        return getOptionValue(option) === getSelectedValue();
      });
    }
    function setSelectedValue(value) {
      emit(EVENT_INPUT, value);
      emit(SELECT_EVENT, value);
    }
    function clearSelectedValue() {
      setSelectedValue(null);
    }
    function setSelectedOption(option) {
      setSelectedValue(getOptionValue(option));
    }
    function isDefaultLabelKey() {
      return select.labelKey === DEFAULT_LABEL_KEY;
    }
    function getOptionLabel(option) {
      return option[select.labelKey];
    }
    function isDefaultValueKey() {
      return select.valueKey === DEFAULT_VALUE_KEY;
    }
    function getOptionValue(option) {
      return option[select.valueKey];
    }
    function setDictCache(options) {
      setOptionsCache("".concat(DICT_CACHE_KEY_PREFIX).concat(prop.dictCode), options);
    }
    function setLoaderCache(options) {
      setOptionsCache("".concat(LOADER_CACHE_KEY_PREFIX).concat(prop.loader), options);
    }
    function setOptionsCache(key, options) {
      if (enableCache.value && options && options.length > 0) {
        localStorage.setItem(key, JSON.stringify(options));
      }
    }
    function getDictCache() {
      return JSON.parse(localStorage.getItem("".concat(DICT_CACHE_KEY_PREFIX).concat(prop.dictCode)) || '[]');
    }
    function getLoaderCache() {
      return JSON.parse(localStorage.getItem("".concat(LOADER_CACHE_KEY_PREFIX).concat(prop.loader)) || '[]');
    }
    function handleFocus() {
      // 执行懒加载
      EXECUTOR.run();
    }
    function startLoading() {
      select.loading = true;
    }
    function stopLoading() {
      select.loading = false;
    }
    function getLoader() {
      if (!prop.loader) {
        return null;
      }
      if (!LOADERS) {
        log('XSelect', '加载失败，未配置加载器：' + GLOBAL_DATA.LOADERS, 'error');
        return null;
      }
      return LOADERS[prop.loader];
    }
    function isLoaderParamSpecified() {
      return prop.loaderParam !== undefined;
    }
    /**
     * 是否存在联动的下拉框
     *
     * @return {boolean} true-存在 false-不存在
     */
    function isCascadedSelect() {
      return prop.on !== null && prop.on !== undefined;
    }
    __expose({
      getSelectedOption: getSelectedOption,
      resetToDefault: resetToDefault,
      appendOptions: appendOptions
    });
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_component_el_select, _mergeProps({
        ref: "selectRef",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(value) ? value.value = $event : null;
        }),
        "filter-method": _unref(realFilter),
        filterable: _unref(smartSearch)
      }, _unref(elProps) || {}, {
        loading: _unref(select).loading
      }, _toHandlers(_ctx.$attrs), {
        onFocus: handleFocus
      }), _createSlots({
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectOptions), function (option, index) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: "".concat(getOptionLabel(option), "-").concat(getOptionValue(option)),
              label: getOptionLabel(option),
              value: getOptionValue(option),
              disabled: _unref(disableOption)(index, getOptionLabel(option), getOptionValue(option), option)
            }, null, 8, ["label", "value", "disabled"]);
          }), 128))];
        }),
        _: 2
      }, [_ctx.$slots.prefix ? {
        name: "prefix",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "prefix")];
        }),
        key: "0"
      } : undefined, _ctx.$slots.empty ? {
        name: "empty",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "empty")];
        }),
        key: "1"
      } : undefined]), 1040, ["modelValue", "filter-method", "filterable", "loading"]);
    };
  }
});